import React, { useState } from "react";
import "./Transfer.css";
import axios from "axios";

const Transfer = () => {

    const [input, setinput] = useState([{
        to: "",
        from: "",
        amount: ""
    }])

    const changehandler = (e) => {

        const { name, value } = e.target;

        setinput(prevtransaction => {
            return {
                ...prevtransaction,
                [name]: value
            }
        })
    }

    const handleclick = (e) => {
        e.preventDefault();

        const newinput = {
            to: input.to,
            from: input.from,
            amount: input.amount
        }

        if(input.to === input.from){
            window.alert("Invalid Account Number");
        }
        else if(input.to == null || input.from == null){
            window.alert("Please Input Account Number");
        } 
        else if(input.amount <=0 || input.amount == null){
            window.alert("Please input some amount");
        }
        else {
            // console.log(newinput);   
            axios.post("https://basic-bank-app.herokuapp.com/transferdata", newinput);
            window.alert("Succesfully Transfered");
            setinput({
                to:"",
                from:"",
                amount:""
            })
        }


    }

    return (
        <>
            <form>
                <div className="transfer_container">
                    <div className="to">
                        <h2>To:</h2>
                        <input onChange={changehandler} value={input.to} type="number" name="to" placeholder="To" min="10021" max="10030" />
                    </div>

                    <div className="from">
                        <h2>From:</h2>
                        <input onChange={changehandler} value={input.from} type="number" name="from" placeholder="From" min="10021" max="10030" />
                    </div>

                    <div className="amount">
                        <h2>Amount :</h2>
                        <input onChange={changehandler} value={input.amount} min="0" type="number" name="amount" placeholder="Amount" />
                    </div>

                    <button onClick={handleclick}>Submit</button>
                </div>
            </form>
        </>
    )
}

export default Transfer;